import CryptoJS from 'crypto-js';

const defaultConfig = {
  orgId: localStorage.getItem('companyid')
    ? CryptoJS.AES.encrypt(localStorage.getItem('companyid'), 'ns0-200200221').toString()
    : 'your-restaurant-id',
  baseUrl: process.env.REACT_APP_SURVEY_BASE_URL || 'https://secure.netshineoffice.com/',
  cdnUrl: 'https://netshine-assets.blr1.cdn.digitaloceanspaces.com',
};

export const generateSurveyLink = (surveyId, surveyKey, orgId = defaultConfig.orgId) => {
  const companyId = localStorage.getItem('companyid');
  const encryptedOrgId = companyId 
    ? encodeURIComponent(CryptoJS.AES.encrypt(companyId, 'ns0-200200221').toString()) 
    : 'your-restaurant-id';
  const key = encodeURIComponent(`${encryptedOrgId}-${surveyId}`);
  return `${defaultConfig.baseUrl}/feedback.html?${key}`;
};

export const decryptSurveyId = (encryptedSurveyId) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedSurveyId, 'ns0-200200221');
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error('Error decrypting survey ID:', err);
    return null;
  }
};

export const decryptOrgId = (encryptedOrgId) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedOrgId, 'ns0-200200221');
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error('Error decrypting org ID:', err);
    return null;
  }
};

export default defaultConfig;